export const EMIT_MAP = {
  onReady: "ready",
  onNotReady: "notReady",
  onBoardMessageReceived: "boardMessageReceived",
  onMessageReceived: "messageReceived",
  onMessageModified: "messageModified",
  onError: "error",
  onWarning: "warning",
  onRecvMGLiveRoomCustomMsg: "recvMGLiveRoomCustomMsg",
  onKickedOut: "kickedOut",
  onLiveGroupChatMessageReceived: "liveGroupChatMessageReceived",
  onMessageRevoked: "messageRevoked",
};
